import { motion } from "framer-motion";
import { fadeUp, viewportOnce } from "./motion";

const NODES = [
  { id: "sonoran", label: "Node 01 / Sonoran", x: 18.9, y: 32.2 },
  { id: "atacama", label: "Node 02 / Atacama", x: 30.8, y: 63.3 },
  { id: "north-sea", label: "Node 03 / North Sea", x: 50.5, y: 17.8 },
  { id: "gulf", label: "Node 04 / Gulf Corridor", x: 63.9, y: 35.6 },
  { id: "pilbara", label: "Node 05 / Pilbara", x: 82.8, y: 62.2 },
  { id: "equatorial", label: "Orbital Relay / Equatorial", x: 50, y: 50 },
];

const STATS = [
  ["Nodes Active", "05"],
  ["Orbital Relays", "01"],
  ["Mean Failover", "140 ms"],
];

export const NodeMap = () => {
  return (
    <section data-testid="node-map-section" className="border-b border-zinc-800">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20 lg:py-32">
        <motion.p
          variants={fadeUp}
          initial="hidden"
          whileInView="show"
          viewport={viewportOnce}
          className="text-[10px] tracking-[0.35em] uppercase text-zinc-500 mb-6"
        >
          Node Lattice / Global Telemetry
        </motion.p>
        <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-6 mb-14">
          <motion.h2
            variants={fadeUp}
            custom={1}
            initial="hidden"
            whileInView="show"
            viewport={viewportOnce}
            className="font-display text-2xl sm:text-3xl lg:text-4xl uppercase tracking-tight font-bold text-white max-w-2xl"
          >
            Active Enclosure Node Lattice
          </motion.h2>
          <motion.p
            variants={fadeUp}
            custom={2}
            initial="hidden"
            whileInView="show"
            viewport={viewportOnce}
            className="text-xs text-zinc-500 max-w-sm leading-relaxed"
          >
            Five terrestrial enclosure nodes and one equatorial orbital relay maintain
            continuous telemetry across the Equinox lattice. Coordinates remain
            restricted to cleared counterparties.
          </motion.p>
        </div>

        <motion.div
          variants={fadeUp}
          custom={2}
          initial="hidden"
          whileInView="show"
          viewport={viewportOnce}
          className="relative border border-zinc-800 bg-[#0A0A0A] overflow-hidden"
        >
          <img
            src="/node-map.png"
            alt="Dotted world map of the Equinox enclosure node lattice"
            className="w-full block"
          />
          {NODES.map((n, i) => (
            <div
              key={n.id}
              data-testid={`node-dot-${n.id}`}
              className="absolute group"
              style={{ left: `${n.x}%`, top: `${n.y}%` }}
            >
              <span
                className="absolute -translate-x-1/2 -translate-y-1/2 inline-flex h-3 w-3 rounded-full bg-white opacity-60 animate-ping"
                style={{ animationDelay: `${i * 0.45}s`, animationDuration: "2.6s" }}
              />
              <span className="absolute -translate-x-1/2 -translate-y-1/2 inline-flex h-1.5 w-1.5 rounded-full bg-white" />
              <span className="absolute left-2 top-2 whitespace-nowrap text-[8px] sm:text-[9px] tracking-[0.25em] uppercase text-zinc-400 opacity-0 group-hover:opacity-100 sm:opacity-60 sm:group-hover:opacity-100 transition-opacity duration-300">
                {n.label}
              </span>
            </div>
          ))}
        </motion.div>

        <div className="grid grid-cols-3 border border-t-0 border-zinc-800">
          {STATS.map(([k, v], i) => (
            <div
              key={k}
              className={`px-4 sm:px-8 py-5 ${i > 0 ? "border-l border-zinc-800" : ""}`}
            >
              <p className="text-[9px] sm:text-[10px] tracking-[0.3em] uppercase text-zinc-500">{k}</p>
              <p className="font-display text-xl sm:text-3xl font-bold text-white mt-1 tabular-nums">{v}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
